import { createElementBlock as a, openBlock as e, createStaticVNode as r } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "64",
  height: "64"
};
function p(i, t) {
  return e(), a("svg", l, t[0] || (t[0] = [
    r('<defs><rect id="app-a" width="64" height="64" x="0" y="0" rx="8"></rect><path id="app-c" d="M64 86.4v64H0v-64z"></path></defs><g fill="none" fill-rule="evenodd"><mask id="app-b" fill="#fff"><use xlink:href="#app-a"></use></mask><use xlink:href="#app-a" fill="#D8D8D8"></use><g mask="url(#app-b)"><g transform="translate(0 -86.4)"><use xlink:href="#app-c" fill="#FFE857"></use><path stroke="#FFF" stroke-width="25" d="M18.5 61.4a61.4 61.4 0 1 0 122.8 0 61.4 61.4 0 0 0-122.8 0z" opacity=".4"></path></g><g transform="translate(12.3 15.6)"><rect width="38.1" height="29.7" x=".6" y=".6" fill="#FFF" stroke="#979797" stroke-width=".1" rx="4.2"></rect><path fill="#FFE857" d="M35.2 26.7a.4.4 0 0 1-.3.4H4.6a.4.4 0 0 1-.3-.4V4.6a.4.4 0 0 1 .3-.4H35c.2 0 .3.2.3.4v22.1z"></path><path fill="#000" d="M37.8 27.3a2.4 2.4 0 0 1-2.3 2.4H4a2.4 2.4 0 0 1-2.3-2.4V4A2.4 2.4 0 0 1 4 1.7h31.5c1.3 0 2.3 1 2.3 2.3v23.3zM35.5 0H4a4 4 0 0 0-4 4v23.4a4 4 0 0 0 4 4h14.5c.2 0 .4.1.4.3v3.7c0 .2.2.4.4.4h1a.4.4 0 0 0 .3-.4v-3.7c0-.2.2-.3.4-.3h14.5a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4z"></path></g></g></g>', 2)
  ]));
}
const s = { render: p };
export {
  s as default,
  p as render
};
